//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import defaultTheme from './DayOfWeekSlotsSummary.scss';
import { MultiDaySlot } from 'common/models/internal/MultiDaySlot';
import { DivWithPopover } from 'common/components/core/wrappers/Div';
import { DayShift } from 'common/models/internal/DayShift';

import {
    PopoverTriggerEnum,
    PopoverPlaceEnum
} from 'common/components/core/popover/popOverFactory';

type Props = {
    timeSlots?: Array<MultiDaySlot>,
    riderSlots?: Array<DayShift>,
    shiftSlots?: Array<DayShift>,
    theme: Object,
    title?: string,
    isBreaksWithOffset?: boolean,
    timeFormat?: string
};

export const dayOfWeekSlotsSummaryFactory = ({
    TimeSlotsSummary,
    TableSlotSummary
}) => {
    class DayOfWeekSlotsSummary extends React.PureComponent<Props> {
        render() {
            const {
                theme,
                timeSlots,
                riderSlots,
                shiftSlots,
                title,
                testId,
                isBreaksWithOffset,
                timeFormat
            } = this.props;
            const entitySlots = shiftSlots || riderSlots || timeSlots;
            return (
                <DivWithPopover
                    place={PopoverPlaceEnum.Row}
                    preferPlace={PopoverPlaceEnum.Below}
                    popOverContent={
                        <TimeSlotsSummary
                            slots={timeSlots || entitySlots}
                            title={title}
                            isBreaksWithOffset={isBreaksWithOffset}
                            timeFormat={timeFormat}
                        />
                    }
                    hidePopoverOnClick
                    triggerPopoverOn={PopoverTriggerEnum.Hover}
                    invertPopover={false}
                >
                    <TableSlotSummary
                        theme={theme}
                        slots={entitySlots}
                        testId={testId}
                    />
                </DivWithPopover>
            );
        }
    }
    return themr(DayOfWeekSlotsSummary, defaultTheme)(DayOfWeekSlotsSummary);
};

export default dayOfWeekSlotsSummaryFactory;
